var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.specialOfferBar)?_c('SpecialOfferBar',{attrs:{"bar-data":_vm.specialOfferBar}}):(_vm.infoBar)?_c('InfoBar',{attrs:{"bar-data":_vm.infoBar}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }